import { useEffect, useState } from "react";
import { debounce } from "underscore";

const useHandleResize = () => {
  const [marginLeft, setMarginLeft] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const container = document.querySelector(".container");
      const left = container?.getBoundingClientRect()?.left || 0;
      setMarginLeft(left);
    };

    const debouncedResize = debounce(handleResize, 50);

    // Initial call
    const timeout = setTimeout(() => {
      handleResize();
    }, 10);

    // Add listener
    window.addEventListener("resize", debouncedResize);
    window.addEventListener("pageshow", handleResize);

    // Clean up
    return () => {
      window.removeEventListener("resize", debouncedResize);
      window.removeEventListener("pageshow", handleResize);
    };
  }, []);

  return marginLeft;
};

export default useHandleResize;
